import { Button, Grid } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";

export const AmountFooter: React.FC<any> = React.memo((props) => {
  return (
    <Grid
      sx={{
        backgroundColor: "#333", // Dark background like in the image
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2} alignItems="center" gap={3}>
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            sx={{ width: "9rem", borderColor: "green", color: "white" }}
            color="success"
          >
            Void
          </Button>
        </Grid>
      </Grid>

      <Grid sx={{ display: "flex", alignItems: "center" }} gap={2}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
        >
          Add
        </Button>
      </Grid>
    </Grid>
  );
});
